import React from 'react'
import Header from '../../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../../component/custom-hooks/get-nav'

const WaterTankerOrgLayout = () => {
  const navList = useNav();
  let { waterOrgBottom, waterTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={waterOrgBottom} topTabs={waterTopHeader} />
      <Outlet />
    </div>
  )
}

export default WaterTankerOrgLayout
